/**
 * ХОД 1 — метки времени CV-пробы (ArticulationGame, mode="clinical").
 * Один прогон → готовая разбивка «камера / транспорт / CV-модуль» для разговора с СТО.
 */

let marks = {};
let onceSet = new Set();
let t0 = 0;

export function markCv(name) {
  const now = performance.now();
  if (!t0) t0 = now; // первая метка прогона = точка отсчёта
  marks[name] = now;
}

/** Метка «не чаще одного раза за прогон» (первое сообщение, connected и т.п.). */
export function markCvOnce(name) {
  if (onceSet.has(name)) return;
  onceSet.add(name);
  markCv(name);
}

/** Новая попытка (handleStartCamera, handleRetry) = новый таймлайн. */
export function resetCvMarks() {
  marks = {};
  onceSet = new Set();
  t0 = 0;
}

export function reportCv(label) {
  const seq = Object.entries(marks)
    .map(([n, ts]) => `${n} ${Math.round(ts - t0)}ms`)
    .join(" → ");

  const camStart = marks["camera:start"];
  // Граница «камера/сервер»: gum:done если клиент пропатчен, иначе camera:ready.
  const camBoundary = marks["gum:done"] ?? marks["camera:ready"];
  const srvReady = marks["server:ready"];

  const cam = camStart != null && camBoundary != null ? Math.round(camBoundary - camStart) : null;
  const srv = camBoundary != null && srvReady != null ? Math.round(srvReady - camBoundary) : null;

  let line = `[AG][CV-TIME] ${label}: ${seq || "нет меток"} | total ${Math.round(performance.now() - t0)}ms`;
  if (cam != null && srv != null && cam + srv > 0) {
    line += ` | камера ${cam}ms (${Math.round((cam / (cam + srv)) * 100)}%) / сервер ${srv}ms (${Math.round((srv / (cam + srv)) * 100)}%)`;
  }
  console.log(line);

  marks = {};
  onceSet = new Set();
  t0 = 0;
}